import Reveal from "@/components/Reveal";

function ImageCard({ src, alt, label, sub, className = "", testid }) {
    return (
        <div className={`group relative overflow-hidden rounded-3xl ${className}`} data-testid={testid}>
            <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5">
                <span className="inline-block rounded-full border border-white/25 bg-white/10 px-4 py-2 text-xs font-semibold tracking-wide text-white backdrop-blur-md">
                    {label}
                </span>
                {sub && <p className="mt-2 text-xs text-stone-200">{sub}</p>}
            </div>
        </div>
    );
}

export default function RichExperience({ data }) {
    if (!data) return null;
    return (
        <section className="bg-sand py-24 sm:py-32" data-testid="experience-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal>
                    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold-hover">{data.eyebrow}</p>
                    <h2 className="mt-3 max-w-2xl font-serif text-3xl font-semibold tracking-tight text-forest-deep sm:text-4xl lg:text-5xl">
                        {data.title}
                    </h2>
                    <p className="mt-4 max-w-2xl text-base leading-relaxed text-stone-600">{data.intro}</p>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-12">
                    <Reveal className="md:col-span-7">
                        <ImageCard
                            src={data.big.img}
                            alt={data.big.label}
                            label={data.big.label}
                            sub={data.big.sub}
                            className="h-[380px] md:h-[520px]"
                            testid="experience-card-big"
                        />
                    </Reveal>

                    <Reveal className="md:col-span-5" delay={0.12}>
                        <div className="flex h-[380px] flex-col justify-between rounded-3xl bg-forest-deep p-8 md:h-[520px]" data-testid="experience-card-text">
                            <div>
                                <span className="inline-flex items-center gap-2 rounded-full bg-gold/15 px-4 py-2 text-xs font-semibold tracking-wide text-gold">
                                    {data.textCard.chip}
                                </span>
                                <h3 className="mt-5 font-serif text-2xl font-semibold text-white sm:text-3xl">
                                    {data.textCard.title}
                                </h3>
                            </div>
                            <ul className="space-y-3">
                                {data.textCard.bullets.map((b) => (
                                    <li key={b} className="flex items-center gap-3 text-sm text-stone-200">
                                        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />
                                        {b}
                                    </li>
                                ))}
                            </ul>
                            <p className="text-xs font-medium uppercase tracking-[0.18em] text-gold/80">{data.textCard.foot}</p>
                        </div>
                    </Reveal>

                    <Reveal className="md:col-span-4" delay={0.05}>
                        <ImageCard src={data.small1.img} alt={data.small1.label} label={data.small1.label} className="h-[340px]" testid="experience-card-small-1" />
                    </Reveal>

                    <Reveal className="md:col-span-4" delay={0.15}>
                        <div className="flex h-[340px] flex-col justify-between rounded-3xl bg-gold p-8" data-testid="experience-card-gold">
                            <span className="inline-flex w-fit items-center gap-2 rounded-full bg-forest-deep/10 px-4 py-2 text-xs font-semibold tracking-wide text-forest-deep">
                                {data.goldCard.chip}
                            </span>
                            <div>
                                <h3 className="font-serif text-2xl font-semibold text-forest-deep">{data.goldCard.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-forest-deep/80">{data.goldCard.text}</p>
                            </div>
                        </div>
                    </Reveal>

                    <Reveal className="md:col-span-4" delay={0.25}>
                        <ImageCard src={data.small2.img} alt={data.small2.label} label={data.small2.label} className="h-[340px]" testid="experience-card-small-2" />
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
